
import { defineComponent } from 'vue';
import Skeleton from 'primevue/skeleton';

export default defineComponent({
  name: 'RelatedPartsTableSkeleton',
  components: {
    Skeleton
  },
  props: {
    skeletonCount: {
      type: Number,
      default: 2
    }
  }
});
